import * as React from 'react';
import { useSelector } from 'react-redux';
import { EPageTypes, EPlatformTypes } from '@cian/frontend-dynamic-calltracking-component';
import { IBaseButtonProps } from '@cian/ui-kit/button/types';
import { FicheringCall } from '@cian/frontend-newbuilding-call-component';
import { getBuilder } from '../../selectors/builder';
import { getSellers } from '../../selectors/sellers';
import { IDeveloper } from '../../types/developer/developer';
import { IUser } from '../../types/user/user';
import { getDeveloper, getUser } from '../../selectors';
import { ApplicationContext } from '../../utils';

interface ICallProps {
  onShowPhone?(developer: IDeveloper, user: IUser): void;
  openContactsStyles?: IBaseButtonProps;
  showPhoneStyles?: IBaseButtonProps;
}

export function Call({ onShowPhone, openContactsStyles, showPhoneStyles }: ICallProps) {
  const context = React.useContext(ApplicationContext);
  const developer = useSelector(getDeveloper);
  const rawBuilder = useSelector(getBuilder);
  const rawSellers = useSelector(getSellers);
  const user = useSelector(getUser);

  /* Логика телефонов на карточке застройщика:
   * Если есть застройщик с признаком showPhone: true, то отображается контакт застройщика
   * Иначе подставляются контакты представителей
   */
  const builders = React.useMemo(() => {
    return rawBuilder?.showPhone ? [rawBuilder] : [];
  }, [rawBuilder]);
  const sellers = React.useMemo(() => (builders.length ? [] : rawSellers), [builders, rawSellers]);

  const pageType = EPageTypes.NewbuildingCard;
  const platformType = EPlatformTypes.WebDesktop;
  const placeType = 'developerCardContacts';

  const handleShowPhone = React.useCallback(() => {
    // istanbul ignore else
    if (onShowPhone) {
      onShowPhone(developer, user);
    }
  }, [developer, user, onShowPhone]);

  return (
    <FicheringCall
      pageType={pageType}
      platformType={platformType}
      placeType={placeType}
      onShowPhoneClick={handleShowPhone}
      httpApi={context.httpApi}
      logger={context.logger}
      showPhoneStyles={showPhoneStyles}
      openContactsStyles={openContactsStyles}
      builders={builders}
      sellers={sellers}
    />
  );
}
